import {
  any,
  string,
  div,
  IOWidget,
  Action,
  stateful,
  Option,
  a,
  mk_MarkupContent,
  mk_widget,
  AsyncState,
  async,
  button,
  unloadedAsyncState,
  nothing,
  loadingAsyncState,
  Widget,
  Pair,
  mk_pair,
  none,
  hn,
  Fun
} from 'widgets-for-react'
import * as Immutable from 'immutable'
import * as React from 'react'
import { Map, TileLayer, Marker, Popup, Tooltip, MapProps, CircleMarker } from 'react-leaflet'
import L, { LatLngLiteral, FitBoundsOptions, LeafletEvent, map } from 'leaflet'
import MarkerClusterGroup from 'react-leaflet-markercluster'
import { OpenStreetMapProvider } from 'leaflet-geosearch'
import 'leaflet-providers'
import {
  MapsState,
  SearchResult,
  OpenStreetMapProviderResultRaw,
  MapEntity,
  CategoriesList,
  SimpleList,
  MapSearchResult
} from './maps_types'
import {
  provider,
  boundsOptions,
  hoppinger,
  generateMapPoints,
  distanceLimit,
  center_amersfoort,
  generateMapEntity,
  example_pointerIcon,
  mocked_up_categories,
  getDistance,
  mocked_up_tile_provides,
  sample_MapStyling,
  are_cord_same,
  update_selection_status,
  example_icon3,
  example_plus,
  locationToString
} from './maps_utils'
import { select } from './select'
import { WordPress } from '../wordpress/wordpress_api'
import { map_address_to_map_entity } from '../public_site/blocks/custom_blocks/widgets/mapBlock'

export let __private_presentation_kind = ''
export const maps_no_stateful = function(state: MapsState): Widget<Action<MapsState>> {
  let data: CategoriesList =
    state.data_to_display.kind == 'list_category'
      ? state.data_to_display
      : {
          kind: 'list_category',
          selected_category: '',
          categories: Immutable.List([{ title: '', entities: state.data_to_display.entities }])
        }
  let _selected_category = data.categories.find(c => c.title == data.selected_category)
  let selected_category:
    | { title: string; entities: Immutable.List<WordPress.LocationResponse> }
    | 'none' = _selected_category == undefined ? 'none' : _selected_category
  __private_presentation_kind = state.presentation_mode.value.kind
  const locations =
    state.data_to_display.kind == 'simple_list'
      ? state.data_to_display.entities
      : state.data_to_display.categories
          .filter(c => c.title == (state.data_to_display as any).selected_category)
          .first().entities
  const countries = locations
    .map(l => ({
      label: l.acf.country,
      value: locationToString(l),
      selected: locationToString(l) == state.search_status.value
    }))
    .toArray()
  return div<Action<MapsState>>({
    className: state.styling.root,
    key: state.presentation_mode.value.kind
  })(
    div<Action<MapsState>>({ className: state.styling.root__inner })([
      state.header(state),
      div<Action<MapsState>>({ className: state.styling.root__search })([
        state.search_status.kind == 'search'
          ? async<MapSearchResult>()(state.search_status.async).map<Action<MapsState>>(a => s => {
              if (s.search_status.kind == 'input') return s
              let a1 = a(s.search_status.async)
              if (a1.kind == 'loaded') {
                if (a1.value.centers.features.length > 0) {
                  let new_center = a1.value.centers.features[0]
                  let y = +new_center.geometry.coordinates[1]
                  let x = +new_center.geometry.coordinates[0]
                  let point = new L.LatLng(Number.isNaN(y) ? 0 : y, Number.isNaN(x) ? 0 : x)
                  let zoom_options: L.ZoomPanOptions = { animate: false }

                  if (s.map != 'none') {
                    s.map.leafletElement.setView(point, 6, zoom_options)
                  }
                  let new_data_to_display = s.data_to_display

                  if (a1.value.new_data.v.kind == 'r') {
                    new_data_to_display = a1.value.new_data.v.v
                  }

                  return {
                    ...s,
                    search_status: {
                      ...s.search_status,
                      kind: 'input',
                      value: s.search_status.value
                    },
                    center_marker: s.center_marker
                      ? { ...s.center_marker, position: point }
                      : undefined,
                    data_to_display: new_data_to_display,
                    last_searched_center: point,
                    optional_bounds:
                      selected_category == 'none'
                        ? []
                        : selected_category.entities
                            .map(map_address_to_map_entity)
                            .map(p => [p.position.lat, p.position.lng] as [number, number])
                            .filter(p => getDistance({ lat: p[1], lng: p[0] }, point) < 5000)
                            .toArray()
                  }
                } else {
                  alert('Invalid search input')
                }
                return { ...s, search_status: { kind: 'input', value: s.search_status.value } }
              }
              return { ...s, search_status: { ...s.search_status, async: a1 } }
            })
          : nothing(),
        string({
          readonly: true,
          readonly_element: 'p',
          className: state.styling.root__search__label
        })(state.search_label).never(),
        select({
          className: state.styling.root__search__input
        })(countries).map<Action<MapsState>>(a => s => {
          if (s.map != 'none' && s.data_to_display.kind == 'simple_list') {
            let result = s.data_to_display.entities.find(l => a == locationToString(l))
            if (result != null) {
              s.map.leafletElement.setView(L.latLng(parseFloat(result.acf.latitude), parseFloat(result.acf.longitude)), 5)
            } else {
              s.map.leafletElement.setView(center_amersfoort, 5)
            }
          }
          return {
            ...s,
            search_status: {...s.search_status, value: a },
            last_searched_center: a == '' ? 'none' : s.last_searched_center
          }
        })
      ]),
      state.presentation_mode.value.kind != 'show list' && selected_category != 'none'
        ? mk_widget({
            run: (set_state: (_: Action<MapsState>) => void) => {
              let bounds: L.LatLngBoundsExpression = state.optional_bounds
              //selected_category == "none" ? [] : selected_category.entities.map(p => ([p.position.lat, p.position.lng] as [number, number])).toArray()

              let _input_markers =
                selected_category == 'none'
                  ? null
                  : selected_category.entities
                      // .filter(e => {
                      //   if(state.map == "none") return false
                      //   let res = state.map.leafletElement.getBounds().contains(e.position)
                      //   return true
                      // })
                      .toArray()

              let input_markers = _input_markers.map(l => {
                const e = map_address_to_map_entity(l)
                return (
                  <Marker
                    icon={e.icon(e)}
                    state={e.selection_status}
                    position={e.position}
                    onpopupclose={(): void => {
                      if (state.presentation_mode.value.kind != __private_presentation_kind) return
                      update_selection_status(set_state, state.data_to_display, e, 'none')
                    }}
                    onmouseover={(event: L.LeafletMouseEvent): void =>
                      !(
                        e.selection_status == 'selected_in_list' ||
                        e.selection_status == 'selected_on_map'
                      )
                        ? update_selection_status(
                            set_state,
                            state.data_to_display,
                            e,
                            'hovered_on_map'
                          )
                        : null
                    }
                    onmouseout={(event: L.LeafletMouseEvent): void =>
                      !(
                        e.selection_status == 'selected_in_list' ||
                        e.selection_status == 'selected_on_map'
                      )
                        ? update_selection_status(set_state, state.data_to_display, e, 'none')
                        : null
                    }
                    onclick={(event: L.LeafletMouseEvent): void =>
                      update_selection_status(
                        set_state,
                        state.data_to_display,
                        e,
                        'selected_on_map'
                      )
                    }
                  >
                    {e.show_info_on_map == 'on_click' ? (
                      <Popup>{e.info_when_on_map(e)}</Popup>
                    ) : (
                      <Tooltip direction='bottom'>{e.info_when_on_map(e)}</Tooltip>
                    )}
                  </Marker>
                )
              })

              return (
                <div className={state.styling.root__map}>
                  <Map
                    ref={map => {
                      if (map != undefined && state.map == 'none') {
                        L.tileLayer(
                          'https://tiles.stadiamaps.com/tiles/outdoors/{z}/{x}/{y}{r}.png',
                          {
                            attribution:
                              '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                          }
                        ).addTo(map.leafletElement)
                        set_state(s => {
                          let zoom = map.leafletElement.getZoom()
                          let center =
                            s.last_searched_center != 'none'
                              ? s.last_searched_center
                              : s.default_center
                          let center_marker = s.center_marker
                            ? { ...s.center_marker, position: center }
                            : s.center_marker

                          map.leafletElement.setView(center, zoom ? zoom : 2, { animate: false })

                          return { ...s, map, last_center_on_map: center, center_marker }
                        })
                      }
                    }}
                    preferCanvas={true}
                    onresize={e => {
                      set_state(s => {
                        if (s.map == 'none') return s
                        let center = s.map.leafletElement.getCenter()
                        return {
                          ...s,
                          last_event: e,
                          // current_center: center,
                          // internal_prev_center:s.current_center,
                          last_center_on_map: center,
                          center_marker: s.center_marker
                            ? { ...s.center_marker, position: center }
                            : null
                        }
                      })
                    }}
                    //center={state.current_center}
                    bounds={bounds && bounds.length == 0 ? undefined : bounds}
                    boundsOptions={boundsOptions}
                    maxZoom={6}
                    onmoveend={e => {
                      if (state.map == 'none') return

                      looping += 1

                      if (looping > 1) {
                        return
                      }
                      //move end generates too many events when solving popup positions

                      let try_sleep = last_loop =>
                        setTimeout(() => {
                          if (last_loop == looping) {
                            looping = 0
                            if (state.map == 'none') return

                            let center = state.map.leafletElement.getCenter()
                            if (state.last_center_on_map != 'none')
                              if (getDistance(center, state.last_center_on_map) == 0) return

                            set_state(s => {
                              if (s.map == 'none') return s
                              let center = s.map.leafletElement.getCenter()
                              return {
                                ...s,
                                last_event: e,
                                last_center_on_map: center,
                                center_marker: s.center_marker
                                  ? { ...s.center_marker, position: center }
                                  : null
                              }
                            })
                          } else {
                            try_sleep(looping)
                          }
                        }, 100)
                      try_sleep(looping)
                    }}
                    onzoomend={e => {
                      if (state.map == 'none') return
                      if (looping > 0) {
                        return
                      }
                      set_state(s => {
                        if (s.map == 'none') return s
                        let zoom = s.map.leafletElement.getZoom()
                        let center = s.map.leafletElement.getCenter()
                        return {
                          ...s,
                          last_event: e,
                          current_zoom: zoom,
                          last_center_on_map: center,
                          center_marker: s.center_marker
                            ? { ...s.center_marker, position: center }
                            : null
                        }
                      })
                    }}
                  >
                    {input_markers}
                    {/* {state.center_marker ? <Marker  position={state.center_marker.position} icon={state.center_marker.icon(state.center_marker)}/> : null}                       */}
                  </Map>
                </div>
              )
            }
          })
        : nothing(),
      state.presentation_mode.value.kind == 'show list and map' ||
      state.presentation_mode.value.kind == 'show list'
        ? div<Action<MapsState>>({ className: state.styling.root__list })(
            div<Action<MapsState>>({ className: state.styling.root__list__content })(function(): Widget<Fun<MapsState, MapsState>> | Widget<Fun<MapsState, MapsState>>[] {
              return selected_category == 'none'
                ? [
                    string({ readonly: true, readonly_element: 'p' })(
                      'No data to display. Select a category first.'
                    ).never()
                  ]
                : selected_category.entities
                    .filter(a => {
                      if(state.search_status.value == "") return true
                      return locationToString(a) == state.search_status.value
                    })
                    .map(
                      (l): Widget<Action<MapsState>> => {
                        const e = map_address_to_map_entity(l)
                        let widget: Widget<Action<MapsState>> = mk_widget({
                          run: set_state => {
                            return (
                              <li
                                className='list__item'
                                onMouseOver={() =>
                                  !(
                                    e.selection_status == 'selected_in_list' ||
                                    e.selection_status == 'selected_on_map'
                                  )
                                    ? update_selection_status(
                                        set_state,
                                        state.data_to_display,
                                        e,
                                        'hovered_in_list'
                                      )
                                    : null
                                }
                                onMouseOut={() =>
                                  !(
                                    e.selection_status == 'selected_in_list' ||
                                    e.selection_status == 'selected_on_map'
                                  )
                                    ? update_selection_status(
                                        set_state,
                                        state.data_to_display,
                                        e,
                                        'none'
                                      )
                                    : null
                                }
                                onClick={() =>
                                  update_selection_status(
                                    set_state,
                                    state.data_to_display,
                                    e,
                                    'selected_in_list'
                                  )
                                }
                              >
                                {e.info_when_on_list(e, state.presentation_mode)}
                              </li>
                            )
                          }
                        })

                        if (state.presentation_mode.value.kind == 'show list') {
                          let center =
                            state.last_searched_center != 'none'
                              ? state.last_searched_center
                              : state.default_center //state.map.leafletElement.getCenter()
                          if (
                            getDistance(center, e.position) <=
                            state.presentation_mode.value.current_range
                          )
                            return widget
                        }
                        if (state.map == 'none') return nothing()
                        let getBounds = state.map.leafletElement.getBounds()
                        if (getBounds.contains(e.position))
                          //return string()(`${getDistance(state.current_center, m.position)}`).never()
                          return widget
                        return nothing<Action<MapsState>>()
                      }
                    )
                    .toArray()
            }())
          )
        : nothing()
    ])
  )
}
let looping = 0
export const maps = function(init_state: MapsState) {
  return stateful<MapsState>()(state =>
    maps_no_stateful(state).map((action: Action<MapsState>) => {
      let s1 = action(state)
      // console.log("new state", s1)
      return s1
    })
  )(init_state)
}

// export let mapsExample: Sample = ({
//   widget: () => maps(sample2_initial_state(mocked_up_categories)),
//   // widget: () => maps(sample1_initial_state),
//   path: "/examples/maps",
//   name: "Maps",
//   category: "maps",
//   documentation: function () {
//     return {
//       ...mk_MarkupContent("Markdown"), text: `# Maps

// This sample shows a map sample made with the open maps library and React-Leaflet.`
//     }
//   }
// })
